<template>
  <div class="el-input">
    <div class="el-row">
      <div class="cp-field cp-field--ilabel">
        <CustomInput :label="L.inputLabel || 'Input label'" :value="element.labels[lang]" @input="updateLabel($event)" />
      </div>
      <div class="cp-field cp-field--itype">
        <label class="cp-label">{{ L.inputType || 'Type' }}</label>
        <CustomSelect :value="element.inputType" :options="typeOptions" @input="setType($event)" />
      </div>
      <!-- Minimum amount + charge mode only apply to money inputs. -->
      <div v-if="element.inputType === 'money'" class="cp-field cp-field--min">
        <CustomInput :label="L.minAmount || 'Minimum amount (€)'" type="number" :value="element.minAmount" @input="set('minAmount', $event)" />
      </div>
      <div v-if="element.inputType === 'money'" class="cp-field cp-field--charge">
        <label class="cp-label">{{ L.chargeMode || 'Charge' }}</label>
        <CustomSelect :value="element.charge || 'one_time'" :options="chargeOptions" @input="set('charge', $event)" />
      </div>
    </div>
    <div class="el-toggles">
      <CustomSwitch :value="element.required" :label="L.required || 'Required'" @input="set('required', $event)" />
      <CustomSwitch
          v-if="element.inputType === 'money'"
          :value="element.includeInSummary"
          :label="L.includeInSummary || 'Include in summary'"
          @input="set('includeInSummary', $event)" />
    </div>
  </div>
</template>

<script>
import CustomInput from '../../../../parts/CustomInput.vue'
import CustomSelect from '../../../../parts/CustomSelect.vue'
import CustomSwitch from '../../../../parts/CustomSwitch.vue'

/**
 * 'input' element: a fill-in field, text or money. Money adds 'include in summary'.
 * Stores its label per language; mutates the element in place.
 */
export default {
  name: 'ElInput',
  components: { CustomInput, CustomSelect, CustomSwitch },
  props: {
    options: { type: Object, required: true },
    element: { type: Object, required: true },
    lang: { type: String, default: 'de' }
  },
  computed: {
    L() { return this.options.Lang || {}; },
    typeOptions() {
      const L = this.L;
      return [
        { value: 'text', label: L.inputType_text || 'Text' },
        { value: 'money', label: L.inputType_money || 'Money (€)' }
      ];
    },
    chargeOptions() {
      const L = this.L;
      return [
        { value: 'one_time', label: L.chargeOneTime || 'One-time' },
        { value: 'per_traveler', label: L.chargePerTraveler || 'Per traveler' }
      ];
    }
  },
  methods: {
    set(key, val) { this.element[key] = val; },
    setType(val) {
      this.element.inputType = val;
      if (val !== 'money') { this.element.includeInSummary = false; this.element.minAmount = ''; this.element.charge = 'one_time'; }
    },
    updateLabel(val) { this.$set(this.element.labels, this.lang, val); }
  }
};
</script>

<style scoped>
.el-input { width: 100%; }
.el-row { display: flex; align-items: flex-end; gap: 0.7rem; flex-wrap: wrap; }
.cp-field { display: flex; flex-direction: column; min-width: 0; }
.cp-field--ilabel { flex: 1; min-width: 160px; }
.cp-field--itype { width: 150px; }
.cp-field--min { width: 160px; }
.cp-field--charge { width: 150px; }
.el-toggles { display: flex; gap: 1.25rem; margin-top: 0.6rem; flex-wrap: wrap; }
.cp-label { display: block; font-size: 0.78rem; font-weight: 600; color: #555; margin-bottom: 0.25rem; }
</style>
